import { lazy } from 'react'

export const WhatElse = lazy(() => import('./WhatElse'))
